import { render, staticRenderFns } from "./VoucherUtilizado.vue?vue&type=template&id=0fbb6266&scoped=true"
import script from "./VoucherUtilizado.vue?vue&type=script&lang=js"
export * from "./VoucherUtilizado.vue?vue&type=script&lang=js"
import style0 from "./VoucherUtilizado.vue?vue&type=style&index=0&id=0fbb6266&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbb6266",
  null
  
)

export default component.exports